import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { EServiceType, IPublishOption } from '../../../../reducers';

interface IMapCalltrackingTermParams {
  period: IPublishOption;
  services: Array<EServiceType>;
}

export function mapCalltrackingTerm(params: IMapCalltrackingTermParams): ICheckPublishTermSchema {
  const { period, services } = params;
  const { type, days, tariffIdentificator } = period;

  return {
    type,
    days,
    services,
    tariffIdentificator,
  };
}
